export default {"src":"/_next/static/image/public/assets/icons/block.92b93fea95c15b2dca78c6bacdfc6c0f.svg","height":24,"width":24};